/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, ViewEncapsulation, AfterViewInit, OnInit, AfterViewChecked, HostListener } from '@angular/core';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { CheckedUncheckedPipe } from '../../shared/pipes/checkedUnchecked.pipe';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { OutagesService } from '../services/outages.service';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { Subscription } from 'rxjs';
import { OutagesFilterInfo } from '../model/outagesfilterinfo';
import { CommonConstants } from '../../../../common/constants/common-constants';
declare var $: any;

@Component({
  selector: 'zsd-outagesfilter',
  templateUrl: '../view/outagesfilter.component.html',
  providers : [ CheckedUncheckedPipe ],
  encapsulation: ViewEncapsulation.None
})
export class OutagesFilterComponent implements AfterViewInit, OnInit, AfterViewChecked {

  static searchString = null;
  static selectedCategories = null;
  static selectedItemTypes = null;
  static categoryIds = null;
  categoryResults = new Array<ItemCategoriesResultEntity>();
  itemTypesResults = new Array<ItemTypesResultEntity>();
  searchCategory:  string;
  searchItemType: string;
  outagesFilterInfo: OutagesFilterInfo = new OutagesFilterInfo();
  searchSubscription: Subscription;
  windowSize;
  isFilterOpen: boolean;
  showOutagesTab: boolean;

  categoryChecked = false;
  itemTypeChecked = false;

 constructor(private outageService: OutagesService, private checkedUncheckedPipe: CheckedUncheckedPipe,
  private router: Router, private route: ActivatedRoute, private location: PlatformLocation) {
   this.windowSize = window.innerWidth;
   this.router.events.subscribe(
    () => {
        if (this.router.url.includes('/currentoutages')) {
            this.showOutagesTab = true;
        } else { this.showOutagesTab = false; }
    }
);
   this.initializeParameters();
   this.location.onPopState(() => {
     this.ngOnInit();
   });
   this.location.onHashChange(() => {
     this.ngOnInit();
   });

 }

 initializeParameters() {
  OutagesFilterComponent.selectedCategories = null;
  OutagesFilterComponent.selectedItemTypes = null;
  OutagesFilterComponent.searchString = null;
  this.outagesFilterInfo.searchTerm = null;
}

ngAfterViewChecked() {
  this.windowSize = window.innerWidth;
}

closeFilter() {
  this.isFilterOpen = false;
  $('#outages_filterpanel_control').width('0');
  $('body').css('overflow-y', 'auto');
}

 ngOnInit() {
  this.initFilter();
}

@HostListener('window:resize', ['$event'])
  onResize() {
    // a hack to fix filter display issue when protrait and landscape mode has mobile and desktop layout respectively.
  }

initFilter() {
  let categoryIds = new Array<number>();
  let itemTypeIds = new Array<number>();
  this.route.queryParams.subscribe(params => {
     if (params['searchTerm']) {
       this.outagesFilterInfo.searchTerm = JSON.parse(params['searchTerm']);
     }
    if (params['categoryIds']) {
      categoryIds = JSON.parse(params['categoryIds']);
      if (categoryIds.length > 0) {
        this.categoryChecked = true;
      }
    }
    if (params['itemTypeIds']) {
      itemTypeIds = JSON.parse(params['itemTypeIds']);
      if (itemTypeIds.length > 0) {
        this.itemTypeChecked = true;
      }
    }
  });

  if (this.outagesFilterInfo.searchTerm !== null) {
    OutagesFilterComponent.searchString = this.outagesFilterInfo.searchTerm.toString();
  }

  this.getCategories(categoryIds);
  this.getItemtypes(itemTypeIds);
}

getCategories(categoryIds: Array<number>) {
  this.outageService.getItemCategories().subscribe(
    (categoryResponse: ItemCategoriesResultEntity[]) => {
          this.categoryResults = categoryResponse;
          for (let categoryId of categoryIds) {
            for (let j = 0; j < this.categoryResults.length; j++) {
              if (this.categoryResults[j].categoryId === categoryId) {
                this.categoryResults[j].checked = true;
              }
            }
          }
          this.categoryResults = this.checkedUncheckedPipe.transform(this.categoryResults, 'categoryName');
    }
  );
}


getItemtypes(itemTypeIds: Array<number>) {
  this.outageService.getItemTypes().subscribe(
    (itemTypesResponses: ItemTypesResultEntity[]) => {
      this.itemTypesResults = itemTypesResponses;

      for (let itemTypeId of itemTypeIds) {
        for (let j = 0; j < this.itemTypesResults.length; j++) {
          if (this.itemTypesResults[j].itemTypeId === itemTypeId) {
            this.itemTypesResults[j].checked = true;
          }
        }
      }
      this.itemTypesResults = this.checkedUncheckedPipe.transform(this.itemTypesResults, 'itemTypeName');
    });
}

applyFilter() {
  this.categoryResults = this.categoryResults.filter(category => category.checked === true);
  this.itemTypesResults = this.itemTypesResults.filter(itemType => itemType.checked === true);

  let categoryIds = new Array<number>();
  for (let itemCategory of this.categoryResults) {
    categoryIds.push(itemCategory.categoryId);
  }

  let itemTypeIds = new Array<number>();
  for (let itemType of this.itemTypesResults) {
    itemTypeIds.push(itemType.itemTypeId);
  }

  if (OutagesFilterComponent.searchString !== null) {
    OutagesFilterComponent.searchString = JSON.stringify(OutagesFilterComponent.searchString);
  }
  if (categoryIds.length > 0) {
    OutagesFilterComponent.selectedCategories = JSON.stringify(categoryIds);
    this.outagesFilterInfo.categoryIds = categoryIds;
  }
  if (itemTypeIds.length > 0) {
    OutagesFilterComponent.selectedItemTypes = JSON.stringify(itemTypeIds);
    this.outagesFilterInfo.itemTypeIds = itemTypeIds;
  }

  let navigationExtras: NavigationExtras = {
    queryParams: {
      'searchTerm': OutagesFilterComponent.searchString,
      'categoryIds': OutagesFilterComponent.selectedCategories,
      'itemTypeIds': OutagesFilterComponent.selectedItemTypes,
    },
    queryParamsHandling: 'merge'
  };
  let addPath: string;
  if (this.showOutagesTab) {
    addPath = '/currentoutages';
  } else { addPath = '/plannedoutages'; }
  this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
  this.router.navigate([CommonConstants.OUTAGES_COMPONENT + addPath], navigationExtras));

  this.closeFilter();
}

 // will be called on click of clear button
 clearFilter() {
  this.resetFilter();
  if (OutagesFilterComponent.searchString !== null) {
    OutagesFilterComponent.searchString = JSON.stringify(OutagesFilterComponent.searchString);
  }
  let navigationExtras: NavigationExtras = {
    queryParams: {
      'searchTerm': OutagesFilterComponent.searchString,
    },
    queryParamsHandling: 'merge'
  };
  let addPath: string;
  if (this.showOutagesTab) {
    addPath = '/currentoutages';
  } else { addPath = '/plannedoutages'; }
  this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
    this.router.navigate([CommonConstants.OUTAGES_COMPONENT + addPath], navigationExtras ));

  this.closeFilter();
}

// will reset the selected filter values
resetFilter() {
  OutagesFilterComponent.selectedCategories = null;
  OutagesFilterComponent.selectedItemTypes = null;
  this.searchCategory = '';
  this.searchItemType = '';
  this.categoryResults.forEach(category => category.checked = false);
  this.itemTypesResults.forEach(itemType => itemType.checked = false);
}

ngAfterViewInit() {
  $(document).ready(function () {
    $('[data-toggle=popover]').popover();
  });
}

}
